import _ from "lodash";

const SecurityService = {
  hasRole: function (roleName) {
    const roleList = JSON.parse(localStorage.getItem("CLASHMATE_ROLE_LIST"));
    return _.includes(roleList, roleName);
  },
  hasAnyRole: function (roleNames) {
    const roleList = JSON.parse(localStorage.getItem("CLASHMATE_ROLE_LIST")) || [];
    return roleNames.some(roleName => _.includes(roleList, roleName));
  },
  getLayout: function () {
    let roleNames = ["ROLE_ADMIN", "ROLE_SUPER_ADMIN", "ROLE_TENANT_ADMIN", "ROLE_LEVEL1", "ROLE_LEVEL2", "ROLE_LEVEL3"]
    const roleList = JSON.parse(localStorage.getItem("CLASHMATE_ROLE_LIST")) || [];
    let isAdminLayout = roleNames.some(roleName => _.includes(roleList, roleName));
    return isAdminLayout ? "crm" : "user";
  }
};

export default SecurityService;
